import { Autocomplete, Box, Grid, TextField } from '@mui/material'
import React, { ChangeEvent, useContext } from 'react'
import { IFinalTechnicalOutcomeListObj } from '../../Models/applicationModels';
import styles from './insights.module.css';
import { INewAnalysisResult } from '../../Models/applicationModels';
import { DashboardInfoContext, DashboardInfoPayload } from '../../Context/dashboardContext';
import { toast } from 'react-toastify';
import { FlagValidUrl } from '../../utils/flagValidUrl';
import AutomatedNotes from './automatedNotes';
import DocumentCard from './components/analysisDetails/documentCard/documentCard.index';
import RecordingLinkTable from '../../Components/updateApplicationAnalysisResultPopup/noteTable/recordingLinkTable';
import { GetFormatTitle } from '../../Components/tableComponent/getTableColumn/getFormattedData';

interface IApplicationAnalysisProps {
    setNewAnalysisResult: React.Dispatch<React.SetStateAction<INewAnalysisResult>>;
    newAnalysisResult: INewAnalysisResult;
}

interface IDocuments {
    id: string;
    docName: string;
    docLink?: string | null;
}

const ApplicationAnalysis = (props: IApplicationAnalysisProps) => {

    const { newAnalysisResult, setNewAnalysisResult } = props
    const { finalTechnicalOutecomeList } = useContext(DashboardInfoContext) as DashboardInfoPayload;

    const ChangeInInput = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setNewAnalysisResult((prevState) => ({
            ...prevState,
            [event.target.name]: event.target.value
        }))
    }

    const flagShowDocuments = !!newAnalysisResult.automatedNotes?.threePsResponseLink ||
        !!newAnalysisResult.automatedNotes?.lnidDeclineDetails?.lnidDetailsFileLink;

    const documents:IDocuments[] = flagShowDocuments ?
        [
            {id: "threePsResponse", docName: "ThreePs Response", docLink: newAnalysisResult?.automatedNotes?.threePsResponseLink},
            {id: "lnidDetails", docName: "Lnid Details", docLink: newAnalysisResult?.automatedNotes?.lnidDeclineDetails?.lnidDetailsFileLink},
            {id: "mvrResponse", docName: "MVR Response", docLink: newAnalysisResult?.automatedNotes?.mvrResponseLink}
        ] : []

    return (
        <Box className={styles.contentGridCtn}>
            <Grid container className={styles.mainOutCtn}>
                {newAnalysisResult.recordingLinks && newAnalysisResult.recordingLinks?.length > 0 ?
                    <>
                        <Grid item xs={12} className={styles.noteHeader}>Recording Links</Grid>
                        <Grid item xs={11} className={styles.linkListItem}>
                            <Grid container className={styles.dataContainer}>
                                <RecordingLinkTable reordingData={newAnalysisResult.recordingLinks} />
                            </Grid>
                        </Grid>
                    </> : <></>
                }
                {flagShowDocuments &&
                    <>
                        <Grid item xs={12} className={styles.noteHeader}>Documents</Grid>
                        <Grid item xs={12} className={styles.linkListItem}>
                            <Grid container className={styles.dataContainer}>
                                {documents.map((document: IDocuments) => (
                                    <DocumentCard key={document.id} docName={document.docName} docLink={document.docLink} />
                                ))}
                            </Grid>
                        </Grid>
                    </>
                }
                <Box className={`${styles.linkDetailContainer} ${styles.textFieldBox}`}>
                    <Box className={styles.noteHeader}>Final Outcome(Technical)</Box>
                    <Autocomplete
                        value={newAnalysisResult.finalOutcome}
                        options={finalTechnicalOutecomeList}
                        getOptionLabel={(option) => {
                            return GetFormatTitle(option.finalTechnicalOutcomeLabel ?? "");
                        }}
                        renderOption={(props, option) => {
                            return <li {...props}>{GetFormatTitle(option.finalTechnicalOutcomeLabel ?? "")}</li>;
                        }}
                        filterOptions={(options: IFinalTechnicalOutcomeListObj[]) => {
                            return options.filter((v: IFinalTechnicalOutcomeListObj) => !v.isDeleted);
                        }}
                        onChange={(event, value) => {
                            setNewAnalysisResult((prevState) => ({
                                ...prevState,
                                finalOutcome: value,
                                finalOutcomeId: value ? value.finalTechnicalOutcomeUid : "",
                            }));
                        }}
                        renderInput={(params) => {
                            return <TextField className={styles.textFieldFont} {...params} placeholder='Select' />;
                        }}
                    />
                </Box>
                <Box className={`${styles.linkDetailContainer} ${styles.textFieldBox}`}>
                    <Box className={styles.noteHeader}>RAS URL</Box>
                    <TextField
                        value={newAnalysisResult.rasUrl}
                        onChange={ChangeInInput}
                        placeholder='RAS URL'
                        fullWidth
                        onBlur={() => {
                            if (newAnalysisResult.rasUrl !== "") {
                                let flagValidInput = FlagValidUrl([newAnalysisResult.rasUrl ?? ""]);
                                if (!flagValidInput) {
                                    toast.error("Please enter valid url");
                                }
                            }
                        }}
                        className={`${styles.question} ${styles.textFieldFont}`}
                        name={"rasUrl"}
                    />
                </Box>
                <Box className={styles.linkDetailContainer}>
                    <Box className={styles.noteHeader}>Notes</Box>
                    <TextField
                        multiline={true}
                        value={newAnalysisResult.notes ?? ""}
                        onChange={ChangeInInput}
                        placeholder='Enter note'
                        className={`${styles.notes} ${styles.textFieldFont}`}
                        name={"notes"}
                    />
                </Box>
                {newAnalysisResult.automatedNotes !== null &&
                    <Box className={styles.linkDetailContainer}>
                        <AutomatedNotes
                            automatedNotesData={newAnalysisResult.automatedNotes}
                        />
                    </Box>

                }
            </Grid>
        </Box>
    )
}

export default ApplicationAnalysis